import { MapHeader } from 'header'
import { MapMenuDrawer as Drawer } from 'ui-components'

import { useMap } from '~map-preview/states/map'
import { Filter } from '~map-preview/App/Layout/Nav/Filter'
import { Info } from '~map-preview/App/Layout/Nav/Info'
import { Search } from '~map-preview/App/Layout/Nav/Search'
import { Settings } from '~map-preview/App/Layout/Nav/Settings'
import { Share } from '~map-preview/App/Layout/Nav/Share'

import { useMapNavStore } from '~map-preview/states/mapNav'

export function Header() {
  const map = useMap()

  const { openMenu, setOpenMenu } = useMapNavStore()

  const handleClick = () => {
    setOpenMenu(true)
  }

  const handleClose = () => {
    setOpenMenu(false)
  }

  return (
    <>
      <MapHeader
        slotProps={{
          MenuButton: {
            onClick: handleClick
          }
        }}
      />

      <Drawer
        map={map}
        open={openMenu}
        onClose={handleClose}
        slots={{
          Filter,
          Search,
          Share,
          Info,
          Settings
        }}
      />
    </>
  )
}
